/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useEffect } from "react";
import { BsPlayFill } from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { HelpVideoNameMap, IHelpContexts } from "../../types/HelpVideosTypes";
import { HelpVideo } from "../HelpVideo";
import { useModal } from "../Modal/Modal";
import WhatsNewButton from "../WhatsNewButton";

const Wrapper = styled.div`
  width: calc(100% - 60px);
  background: #ffffff;
  border-bottom: 1px solid #dddddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  position: fixed;
  z-index: 11;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .icon-button {
    min-width: 42px;
    max-width: 42px;
    min-height: 42px;
    max-height: 42px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #fff;

    border-radius: 5px;
    border: 1px solid #dddddd;

    cursor: pointer;

    svg {
      width: 20px;
      height: 20px;

      color: #555555;
    }

    .tooltip-text {
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0px;
      color: #ffffff;
    }
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  cursor: default;
`;

const TopBarTitle = styled.div`
  font-size: 20px;
  letter-spacing: 0.3px;
  font-weight: 600;
  color: #333333;
`;

const TopBarSubTitle = styled.div`
  font-size: 14px;
  letter-spacing: 0.2px;
  color: #707070;
`;

interface Props {
  title: string;
  subTitle: string;
}

const TopBar = (props: Props): JSX.Element => {
  const { title, subTitle } = props;
  const modalHandler = useModal();

  useEffect(() => {
    global.ps_config = {
      workspace_id: "f8ea5b12-675a-43e1-af7e-19f0464c62d8",
    };

    let script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", "https://cdn.loopedin.io/js/widget.js?v=0.8");
    document.getElementsByTagName("head")[0].appendChild(script);
  }, []);

  return (
    <Wrapper>
      <TitleContainer>
        <TopBarTitle>{title}</TopBarTitle>
        <TopBarSubTitle>{subTitle}</TopBarSubTitle>
      </TitleContainer>
      <ButtonsContainer>
        <div
          className="icon-button"
          onClick={() =>
            modalHandler.pushModal(
              <HelpVideo contextTag={IHelpContexts.Contacts} />,
              HelpVideoNameMap[IHelpContexts.Contacts]
            )
          }
          data-tip
          data-for="openVideo"
        >
          <BsPlayFill />
          <ReactTooltip
            id="openVideo"
            place="bottom"
            effect="solid"
            globalEventOff="click"
            backgroundColor="#333333"
            css={css`
              width: fit-content !important;
              padding: 6px 8px !important;
            `}
          >
            <div className="tooltip-text">Watch Quick Help Video</div>
          </ReactTooltip>
        </div>
        <div
          css={css`
            margin-left: 10px;
          `}
        >
          <WhatsNewButton />
        </div>
      </ButtonsContainer>
    </Wrapper>
  );
};

export default TopBar;
